module.exports = __webpack_public_path__ + "img/noHistory@3x.a4bdaa6e.png";